export const tagsList = [
    { value: 'Энергия солнца' },
    { value: 'Энергия ветра' },
    { value: 'Энергия вод' },
    { value: 'Энергия приливов' },
    { value: 'ВолнЭС' },
    { value: 'ГеоТЭС' },
    { value: 'НпТЭС' },
    { value: 'Биомасса' },
    { value: 'Биогаз' },
    { value: 'Свгаз' },
    { value: 'Уггаз' },
    { value: 'Отходы производства и потребления' },
    { value: 'Атомная энергия' },
    { value: 'Уголь' },
    { value: 'Мазут' },
    { value: 'Дизель' },
    { value: 'Природный газ' },
]
